import { z } from "zod";
import { defineStepConfig } from "../../../registry/helpers";

/**
 * Submit Deposit Remittance Step
 *
 * Hands the remittance on a check deposit file (a remittance advice, or a
 * check's stub) to `RemittanceIntakeService.submit()` with channel `manual`,
 * so the remittance pipeline records the advice and matches its customer and
 * invoices. The deposit picks the advice up from that run when it is read.
 *
 * Idempotent per file: a file whose remittance was already submitted is
 * skipped.
 */
export const submitDepositRemittanceStep = defineStepConfig({
  type: "submit_deposit_remittance",
  name: "Submit Deposit Remittance",
  description:
    "Submit the remittance on a check deposit file to remittance ingestion",
  category: "Data Access",
  libraryModule: "AccountsReceivable",

  inputSchema: z.object({
    depositBatchItemId: z
      .uuid()
      .describe("The deposit's row for the file (from Record Deposit File)"),
  }),

  outputSchema: z.object({
    status: z.enum(["submitted", "skipped"]),
    skipReason: z
      .string()
      .nullable()
      .describe(
        "Why nothing was submitted: already_submitted or deposit_submitted",
      ),
    workflowRunId: z
      .string()
      .nullable()
      .describe(
        "The remittance ingestion run, when submitted or already submitted",
      ),
  }),

  configSchema: z.object({}),

  emits: [] as const,

  execution: {
    startToCloseTimeout: "2 minutes",
    retry: {
      maximumAttempts: 3,
      initialInterval: "5 seconds",
      backoffCoefficient: 2,
    },
  },
});
